<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button *ngIf="allowNueva" class="btn btn-outline-success" type="button" (click)="onAdd()" title="Nueva Unidad de Inspección">
            <i class="fa fa-file-o"></i> Nueva Ud. Inspección
        </button>
        <button *ngIf="!spinnerExport" type="button" class="btn btn-outline-success" [disabled]="!exportIsAvailable" (click)="onExportExcel()" title="Exportar">
            <i class="fa fa-file-excel-o"></i> Exportar </button>
        <button *ngIf="spinnerExport" type="button" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Exportando
        </button>

        <button *ngIf="isTestingVisible" class="btn btn-outline-success testing" [disabled]="isTesting" type="button" (click)="testTransiciones()" title="Test Transiciones">
            <i class="fa fa-free-code-camp"></i> Test Transiciones</button>
    </form>
</nav>

<div class="container-fluid container-list">

    <div class="ms-1 nota-info warning">
        <label class="col-form-label" for=""><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Por defecto, no aparecen resultados con estados: 
                "{{ SIN_ASIGNAR }}" <img class="estado-icono" src="{{ ID_SIN_ASIGNAR | IconoEstadoUnidadInspeccion }}" container="body" ngbTooltip="{{ SIN_ASIGNAR }}" />
                , "{{ BAJA }}" <img class="estado-icono" src="{{ ID_ESTADO_BAJA | IconoEstadoUnidadInspeccion }}" container="body" ngbTooltip="{{ BAJA }}" />
                o "{{ SUSPENDIDA }}" <img class="estado-icono" src="{{ ID_ESTADO_SUSPENDIDA | IconoEstadoUnidadInspeccion }}" container="body" ngbTooltip="{{ SUSPENDIDA }}" />,
                salvo que se seleccione en el desplegable de estados.
        </label>
    </div>

    <app-buscador-unidad-inspeccion-filter *ngIf="campanias && formGroup"
            [formGroup]="formGroup"
            [lastFilter]="payload" [campanias]="campanias"
            [periodos]="periodos" [CAs]="CAs" [tiposSolicitud]="tiposSolicitud" [estadosUnidadInspeccion]="estadosUnidadInspeccion" [EAs]="EAs"
            [provincias]="provincias" [municipios]="municipios" [operadores]="operadores"
            (search)="onSearch($event)" (cleanForm)="onReset()" (campaniaSelected)="onCampaniaSelected($event)"
            (activaSelected)="onActivaSelected($event)" (periodoSelected)="onPeriodoSelected($event)" 
            (caSelected)="onCASelected($event)" (provinciaSelected)="onProvinciaSelected($event)"
            (eaSelected)="getOperadores()" (tipoSolicitudSelected)="getOperadores()"
            >
    </app-buscador-unidad-inspeccion-filter>
        
    <app-buscador-unidad-inspeccion-list *ngIf="searching" 
        [result]="result" [lastFilter]="payload" [userData]="userData" 
        (search)="onSearchLazy($event)" (edit)="onEdit($event)" (view)="onView($event)">
    </app-buscador-unidad-inspeccion-list>

</div>

<!-- Ventana para mostrar el detalle de un recinto PI y sus cultivos -->
<app-recinto-detail-dialog [visible]="recintoDetailVisible" [Id]="recintoPIAIdSelected" [editMode]="false" (closed)="onRecintoDialogClosed($event)"></app-recinto-detail-dialog>

<!-- Ventana para mostrar el detalle de un Almacén -->
<app-codigoconfeccion-detail-dialog [visible]="almacenDetailVisible" [Id]="recintoPIAIdSelected" (closed)="onRecintoDialogClosed($event)"></app-codigoconfeccion-detail-dialog>
